export const CMS_PAGE_MENU_WRAPPER_COMPONENTS_MAP = {
  'career-menu': 'aw-career-menu',
  'petrol-menu': 'aw-petrol-menu',
  'loyalty-program-menu': 'aw-loyalty-program-menu',
  'local-flavors-menu': 'aw-local-flavors-menu',
};

/**
 * Breadcrumb root level for CMS pages whose content carries no `contentRootTypes`.
 * The petrol landing and its subpages are identified by the menu they sit in —
 * the same signal `AwCmsPage` uses to pick their `<h1>` — so they still get the
 * `Főoldal / Benzinkutak / <page>` trail instead of falling back to two levels.
 */
export const CMS_PAGE_MENU_BREADCRUMB_ROOT_TYPE_MAP: Record<string, string> = {
  'petrol-menu': 'petrol',
};
